import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CoffeeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CoffeeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.9533 10.1324C17.7113 10.1324 19.1364 11.5575 19.1364 13.3154C19.1364 15.0734 17.7113 16.4985 15.9533 16.4985"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.2321 8.10643H6.22122C5.27063 8.10643 4.5 8.87701 4.5 9.82765V16.1173C4.5 18.0185 6.04126 19.5597 7.94243 19.5597H12.5109C14.2828 19.5597 15.725 18.216 15.9153 16.4946C14.1753 16.4737 12.7702 15.0603 12.7702 13.3154C12.7702 11.5575 14.1953 10.1324 15.9533 10.1324L15.9533 9.82765C15.9533 8.87701 15.1827 8.10643 14.2321 8.10643Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 21.5C4 21.2238 4.22386 21 4.5 21H15.9533C16.2295 21 16.4533 21.2238 16.4533 21.5C16.4533 21.7761 16.2295 22 15.9533 22H4.5C4.22386 22 4 21.7761 4 21.5Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.18007 2.10636C7.39748 2.27661 7.43571 2.59087 7.26546 2.80829L7.11103 3.0055C6.8941 3.28253 6.8941 3.67181 7.11103 3.94884L7.41988 4.34325C7.41988 4.34325 7.41988 4.34325 7.41988 4.34325C7.92038 4.9824 7.92038 5.88052 7.41988 6.51967L7.26545 6.71688C7.0952 6.93429 6.78094 6.97253 6.56352 6.80228C6.34611 6.63202 6.30788 6.31776 6.47813 6.10034L6.63256 5.90313C6.84949 5.6261 6.84949 5.23682 6.63256 4.95979L6.32371 4.56538C6.32371 4.56538 6.32371 4.56538 6.32371 4.56538C5.82321 3.92623 5.8232 3.02811 6.32371 2.38896C6.32371 2.38896 6.32371 2.38896 6.32371 2.38896L6.47814 2.19175C6.64839 1.97434 6.96265 1.93611 7.18007 2.10636Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5349 2.10636C10.7524 2.27661 10.7906 2.59087 10.6203 2.80829L10.4659 3.0055C10.249 3.28253 10.249 3.67181 10.4659 3.94884L10.7748 4.34325C10.7748 4.34325 10.7748 4.34325 10.7748 4.34325C11.2753 4.9824 11.2753 5.88052 10.7748 6.51967L10.6203 6.71688C10.4501 6.93429 10.1358 6.97253 9.91839 6.80228C9.70098 6.63202 9.66274 6.31776 9.833 6.10034L9.98743 5.90313C10.2044 5.6261 10.2044 5.23682 9.98743 4.95979L9.67858 4.56538C9.67858 4.56538 9.67858 4.56538 9.67858 4.56538C9.17808 3.92623 9.17808 3.02811 9.67858 2.38897C9.67858 2.38897 9.67858 2.38896 9.67858 2.38897L9.83301 2.19175C10.0033 1.97434 10.3175 1.93611 10.5349 2.10636Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8898 2.10636C14.1072 2.27661 14.1455 2.59088 13.9752 2.80829L13.8208 3.0055C13.6038 3.28253 13.6038 3.67181 13.8208 3.94884L14.1296 4.34325C14.1296 4.34325 14.1296 4.34325 14.1296 4.34325C14.6301 4.9824 14.6301 5.88052 14.1296 6.51967L13.9752 6.71688C13.8049 6.93429 13.4907 6.97253 13.2733 6.80227C13.0558 6.63202 13.0176 6.31776 13.1879 6.10034L13.3423 5.90313C13.5592 5.6261 13.5592 5.23682 13.3423 4.95979L13.0334 4.56538C13.0334 4.56538 13.0334 4.56538 13.0334 4.56538C12.5329 3.92623 12.5329 3.02811 13.0334 2.38896C13.0334 2.38896 13.0334 2.38896 13.0334 2.38896L13.1879 2.19175C13.3581 1.97434 13.6724 1.93611 13.8898 2.10636Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CoffeeIcon;
